import { EDIT_FIELD_TYPES } from "../../constants/ApplicationConstants";

export const HARDWARE_APPROVAL_LIST_COLS = [
  {
    key: "Request",
    value: "id",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: true,
    width: "8%",
  },
  {
    key: "Bundle",
    value: "bundle",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: true,
    isSortable: true,
    isHyperLink: false,
    width: "10%",
  },
  {
    key: "Order",
    value: "order",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: true,
    width: "9%",
  },
  {
    key: "Account Name",
    value: "accountName",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    width: "8%",
  },
  {
    key: "Deployment Service Agent",
    value: "deploymentAgent",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    width: "11%",
  },
  {
    key: "Shipping Address",
    value: "shippingAddress",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: true,
    isSortable: true,
    isHyperLink: false,
    width: "10%",
  },
  {
    key: "Contact",
    value: "contact",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: true,
    isSortable: true,
    isHyperLink: false,
    width: "10%",
  },
  {
    key: "Request Date",
    value: "requestDate",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: true,
    isSortable: true,
    isHyperLink: false,
    width: "9%",
  },
  {
    key: "Status",
    value: "status",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    width: "9%",
  },
  {
    key: "Assignee",
    value: "assignee",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    isEditable: true,
    editFieldType: EDIT_FIELD_TYPES.dropDown, // import this from your constants
    width: "7%",
  },
  {
    key: "Request Resolved Date",
    value: "resolvedDate",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "9%",
  },
];
